import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import axios from "axios";
import LandingPage from "@/pages/LandingPage";
import ServicesPage from "@/pages/ServicesPage";
import BookingPage from "@/pages/BookingPage";
import BookingSuccess from "@/pages/BookingSuccess";
import OffersPage from "@/pages/OffersPage";
import LegalPage from "@/pages/LegalPage";
import MembershipSuccess from "@/pages/MembershipSuccess";
import CleanerPortal from "@/pages/CleanerPortal";
import CleanerResetPasswordPage from "@/pages/CleanerResetPasswordPage";
import CustomerAuth from "@/pages/CustomerAuth";
import CustomerDashboard from "@/pages/CustomerDashboard";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AboutPage from "@/pages/AboutPage";
import RecruitmentPage from "@/pages/RecruitmentPage";

// Send httpOnly auth cookies on every request (auth lives in cookies, not localStorage)
axios.defaults.withCredentials = true;

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Core public pages */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/offers" element={<OffersPage />} />
          <Route path="/booking" element={<BookingPage />} />
          <Route path="/booking/success" element={<BookingSuccess />} />
          <Route path="/careers" element={<RecruitmentPage />} />
          <Route path="/legal" element={<LegalPage />} />

          {/* Account / portals */}
          <Route path="/login" element={<CustomerAuth />} />
          <Route path="/account" element={<CustomerDashboard />} />
          <Route path="/team" element={<CleanerPortal />} />
          <Route path="/team/forgot-password" element={<CleanerResetPasswordPage />} />
          <Route path="/team/reset-password" element={<CleanerResetPasswordPage />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />

          {/* Misc */}
          <Route path="/membership/success" element={<MembershipSuccess />} />

          {/* Legacy redirects — consolidated pages */}
          <Route path="/blog" element={<Navigate to="/offers" replace />} />
          <Route path="/coverage" element={<Navigate to="/about#coverage" replace />} />
          <Route path="/partners" element={<Navigate to="/careers" replace />} />
          <Route path="/membership" element={<Navigate to="/offers#membership" replace />} />
          <Route path="/terms" element={<Navigate to="/legal#terms" replace />} />
          <Route path="/privacy" element={<Navigate to="/legal#privacy" replace />} />
          <Route path="/complaints" element={<Navigate to="/legal#complaints" replace />} />
          <Route path="/subscription-policy" element={<Navigate to="/legal#subscription" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
